import { createAsyncThunk } from '@reduxjs/toolkit';
import { mapToReportTokenResponsePayload } from '../../mappers/TokenMapper';
import { getPowerBITokenByReportID } from '../../services/auth.service';
import {
  isValidCode,
  setReportListResponse,
  setReportTokenResponse
} from '../../services/base.service';
import { getReportListModel } from '../../services/report.service';
import { ApiErrorModel } from '../../types/ApiErrorModel';
import { ReportListModel } from '../../types/ReportListModel';
import { defaultReportList } from '../slices/reportSlice';

export const fetchTokenAndReportList = createAsyncThunk(
  'report/fetchTokenAndReportList',
  async (_, thunkAPI) => {
    interface ReportAuthorizationModel {
      data: ReportListModel;
      error?: ApiErrorModel;
    }

    const returnObj: ReportAuthorizationModel = {
      data: defaultReportList,
      error: undefined,
    };

    // Get report list
    const reportListResponse = await getReportListModel({
      signal: thunkAPI.signal,
    });

    // If successful, set session with list and set return value
    if (isValidCode(reportListResponse.status)) {
      setReportListResponse(reportListResponse.data);
      returnObj.data = reportListResponse.data;
    } else {
      returnObj.error = reportListResponse.error;
    }

    return returnObj;
  }
);

export const fetchTokenByReportID = createAsyncThunk(
  'report/fetchTokenByReportID',
  async (reportId: string, thunkAPI) => {
      const tokenResponse = await getPowerBITokenByReportID(reportId, {
        signal: thunkAPI.signal,
      });
      if (isValidCode(tokenResponse.status)) {
        const tokenPayload = mapToReportTokenResponsePayload(
          tokenResponse.data
        );
        setReportTokenResponse(tokenPayload);
        return true;
    }
    else
      return false;
  }
);